import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { LocalDate } from '@fcom/core/utils/tz-date';
import { FinnairBoundItem } from '@fcom/dapi/api/models/finnair-bound-item';

/**
 * Presentational wrapper around `fin-timetable-schedule`: renders `fcom-tabs` bar
 * with one schedule per leg (Departure, plus Return for round trips). CMS lazy-loads it
 * to avoid an NgModule cycle.
 */
@Component({
  selector: 'fin-timetable-schedule-panel',
  templateUrl: './timetable-schedule-panel.component.html',
  styleUrls: ['./timetable-schedule-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TimetableSchedulePanelComponent {
  /** Outbound leg: flights for the selected departure date */
  readonly departureBounds = input.required<FinnairBoundItem[]>();
  readonly departureDate = input<LocalDate | undefined>(undefined);
  readonly departureLoading = input.required<boolean>();
  readonly departureOriginCode = input<string | undefined>(undefined);
  readonly departureDestinationCode = input<string | undefined>(undefined);

  /** Return leg: flights for the selected return date */
  readonly returnBounds = input<FinnairBoundItem[]>([]);
  readonly returnDate = input<LocalDate | undefined>(undefined);
  readonly returnLoading = input<boolean>(false);
  readonly returnOriginCode = input<string | undefined>(undefined);
  readonly returnDestinationCode = input<string | undefined>(undefined);

  readonly showReturnTab = input<boolean>(false);
  readonly returnTabActive = input<boolean>(false);
}
